// extracted by mini-css-extract-plugin
export default {"error-container":"ErrorFallback_error-container__iM7cN"};